import React from "react";
import {Button} from "@material-ui/core";
import BasketButton from "./BasketButtonContainer";

export default ({classes}) => {
    const button = (props) => <Button variant="text" color="primary" className={classes.root} {...props}/>;
    return <BasketButton button={button} fontSize="large"/>;
}